import React from "react";

const MAP = {
  draft: { bg: "#f1f5f9", fg: "#475569", bd: "#cbd5e1" },
  imported: { bg: "#eff6ff", fg: "#1d4ed8", bd: "#bfdbfe" },
  calculated: { bg: "#fef3c7", fg: "#b45309", bd: "#fcd34d" },
  finalized: { bg: "#ecfdf5", fg: "#047857", bd: "#a7f3d0" },
  locked: { bg: "#f5f3ff", fg: "#6d28d9", bd: "#ddd6fe" },
  raised: { bg: "#eff6ff", fg: "#1d4ed8", bd: "#bfdbfe" },
  submitted: { bg: "#e0f2fe", fg: "#0369a1", bd: "#bae6fd" },
  partially_paid: { bg: "#fef3c7", fg: "#b45309", bd: "#fcd34d" },
  paid: { bg: "#ecfdf5", fg: "#047857", bd: "#a7f3d0" },
  overdue: { bg: "#fef2f2", fg: "#b91c1c", bd: "#fecaca" },
  cancelled: { bg: "#f1f5f9", fg: "#64748b", bd: "#cbd5e1" },
  none: { bg: "#f8fafc", fg: "#94a3b8", bd: "#e2e8f0" },
  active: { bg: "#ecfdf5", fg: "#047857", bd: "#a7f3d0" },
  inactive: { bg: "#f1f5f9", fg: "#64748b", bd: "#cbd5e1" },
};

export function StatusBadge({ status }) {
  const key = (status || "none").toLowerCase();
  const c = MAP[key] || MAP.none;
  const label = key.replace(/_/g, " ");
  return (
    <span
      data-testid={`status-badge-${key}`}
      className="inline-flex items-center rounded-md px-2 py-0.5 text-[11px] font-semibold capitalize"
      style={{ background: c.bg, color: c.fg, border: `1px solid ${c.bd}` }}
    >
      {label}
    </span>
  );
}
